import { Provider } from './Provider';
import { Rules } from './Rules';

export class DataResponse {
  /**
   * constructor description
   * @param {Object} data - An object.
   * @param  {String[]} data.clients
   * @param  {String} data._id
   * @param  {Provider} data.provider
   * @param  {String} data.carrier
   * @param  {Boolean} data.enable
   * @param  {String} data.environment
   * @param  {String} data.name
   * @param  {String} data.type
   * @param  {String} data.created_at
   * @param  {String} data.updated_at
   * @param  {Rules} data.rules
  */
  constructor({
    clients, _id, provider, carrier, enable, environment, name, type, created_at, updated_at, rules,
  }) {
    this.clients = clients;
    this._id = _id;
    this.provider = provider ? new Provider(provider) : null;
    this.carrier = carrier;
    this.enable = enable;
    this.environment = environment;
    this.name = name;
    this.type = type;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.rules = rules ? new Rules(rules) : null;
  }

  isProduction() {
    return this.environment === 'production';
  }
}
